<template>
  <div class="divider"></div>
</template>

<script>
export default {
  name: 'ScpmDivider',
}
</script>

<style lang="scss" scoped>
  .divider{
    width: 100%;
    height: 1px;
    margin: 20px 0 0;
    background-color: #E3E5E8;
  }
</style>